export interface INotification {
  id: string
  data: INotificationMetadata
  notifiable_id: number
  notifiable_type: string
  type: NotificationType
  read_at: string | null
  created_at: string
  updated_at?: string
}

// string given by the api in notif.type param
export enum NotificationType {
  REVIEW = "App\\Notifications\\ReviewNotification",
  SOLICITATION = "App\\Notifications\\SolicitationNotification",
  TIC = "App\\Notifications\\LocalDiffuserNotification",
  /** Absent de la base actuelle — conservé pour compatibilité */
  REMOVED_SECONDARY_CATEGORY = "App\\Notifications\\RemoveSecondaryCategoryDatabase",
  SYNC_GOOGLE_ADDRESS = "App\\Notifications\\SyncGoogleAddress",
  REMOVE_ATTRIBUTE = "App\\Notifications\\RemoveAttribute",
  NEW_ATTRIBUTE = "App\\Notifications\\AssociateNewAttribute",
  /** Absent de la base actuelle — conservé pour compatibilité */
  LATE_SYNC = "App\\Notifications\\LateSyncAppNotification",
  FACEBOOK_MISSING_PERMISSION = "App\\Notifications\\FacebookMissingPermission",
  FACEBOOK_CHANGED_PASSWORD = "App\\Notifications\\FacebookChangedPassword",
  FACEBOOK_UNCONFIRMED_USER = "App\\Notifications\\FacebookUnconfirmedUser",
  GOOGLE_MISSING_PERMISSION = "App\\Notifications\\GoogleMissingPermission",
  GOOGLE_ACTION_REQUIRED = "App\\Notifications\\GoogleActionRequiredNotification",
  SUPPORT_REPLY = "App\\Notifications\\SupportReplyNotification",
}

interface INotificationMetadata {
  content: string
  title: NotificationTitle | string
  link?: string | null
  logo?: string | null
  establishmentId?: string | number | null
  pathName?: string | null
  conversation_id?: number | string | null
  support_case_id?: number | string | null
  external_id?: string | null
  directory?: string
  author?: string
  rating?: number
}

export enum NotificationTitle {
  NEW_REVIEW = "NEW_REVIEW",
  TIC_ANSWER = "TIC_ANSWER",
  SUPPORT_REPLY = "SUPPORT_REPLY",
}

/**
 * Notification metadata specific for review notification
 */
export interface IReviewMetadata extends INotificationMetadata {
  directory: string
  author: string
  rating: number
}

export function isReviewMetadata(notif: any): notif is IReviewMetadata {
  if (notif && notif.type === NotificationType.REVIEW) {
    return true
  }
  return false
}

export interface ITicMetadata extends INotificationMetadata {}

export function isTicMetadata(notif: any): notif is ITicMetadata {
  if (notif && notif.type === NotificationType.TIC) {
    return true
  }
  return false
}
